import { render, staticRenderFns } from "./ReplacementMerge.html?vue&type=template&id=37a3859a&external"
import script from "./ReplacementMerge.ts?vue&type=script&lang=ts&external"
export * from "./ReplacementMerge.ts?vue&type=script&lang=ts&external"
import style0 from "./ReplacementMerge.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports